import script from "./guidePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./guidePage.vue?vue&type=script&lang=ts&setup=true"

import "./guidePage.vue?vue&type=style&index=0&id=230e7604&lang=less&scoped=true"

import exportComponent from "/builds/26732/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-230e7604"]])

export default __exports__